export default {
  login: '登录',
  placeholderPwd: '密码 ',
  placeholderCode2: '图形验证码',
  ruleAccount: '请输入账号',
  rulePwd: '请输入密码',
  ruleErrorCode: '请输入正确的图形验证码',
  ruleErrorPhone: '请检查手机号',
  loginSuccess: '登录成功',

  placeholderCode: '短信/邮箱验证码',
  ruleCode: '请输入验证码',
  rulePhone: '请输入手机号/邮箱',
  placeholderAccount: ' 账号/手机/邮箱',
  placeholderCodeLogin: '手机/邮箱',
  passwordLogin: '密码登录',
  codeLogin: '校验码登录',
  placeholderArea: '请选择国家',
  unlockRightSettlementInfo: '解锁创建商品的权利仅需进一步补充结算信息！',
  providingSettlementProceeds: '补充结算信息将会让您及时收取销售结算款。',
  completeNow: '去补充结算信息',
  cancel: '取消',
  obtainVerificationCodeFirst: '请先获取验证码',
  correctMobilePhoneNumberOrEmailAddress: '请填写正确的手机号或邮箱！',
  ObtainGraphicVerificationCode: '请重新获取图形验证码'
}
